<template>
    <div class="header" :class="{ 'onScroll': !topOfPage}">
        <div>
            <mobile-component v-if="isMobile" :links="links" :topOfPage="topOfPage"></mobile-component>
            <desktop-componet v-else :links="links" :topOfPage="topOfPage"></desktop-componet>
        </div>
    </div>
</template>

<script>
import desktopComponet from './desktop/desktop.vue';
import mobileComponent from './mobile/mobile.vue';

export default {
    components: {
        desktopComponet,
        mobileComponent
    },
    name: 'HeaderNewHome',
    data() {
        return {
            isMobile: false,
            topOfPage: true,
            links: [
                {
                    label: 'Vantagens',
                    path: '#vantagens',
                    active: false,
                    show: false
                },
                {
                    label: 'Como Funciona',
                    path: '#como-funciona',
                    active: false,
                    show: false
                },
                {
                    label: 'Solicitar Proposta',
                    path: '#solicitar-proposta',
                    active: false,
                    show: false
                }
            ]
        };
    },
    methods: {
        handleScroll() {
            if (window.pageYOffset > 100) {
                if (this.topOfPage) this.topOfPage = false;
            } else {
                if (!this.topOfPage) this.topOfPage = true;
            }
        }
    },
    beforeMount() {
        window.addEventListener('scroll', this.handleScroll);
    },
    mounted() {
        const vue = this;
        window.addEventListener('resize', () => {
            vue.isMobile = window.innerWidth <= 800;
        });
        vue.isMobile = window.innerWidth <= 800;
    }
};
</script>

<style lang="scss" scoped>
.header {
    background: transparent;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9;
    &.onScroll {
        background-color: #fff;
        box-shadow: 0 0 10px #aaa;
    }
}
</style>
